export const ADDITEM_TO_TAX_LIST = "addItem_to_tax_list";
export const ADDITEM_TO_TAX_LIST_SUCCESSFULL = "addItem_to_tax_list_successfull";
export const API_ERRORS = 'api_failed';